
export function Checked() {
    return <svg className="checked-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="11" fill="currentColor" />
        <path d="M6.1875 11.6875L9.39583 14.8958L15.8125 8.02083" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}